import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import i18n from '../../../app/i18n';

import useForm from '../../../lib/hooks/useForm';
import { api } from '../../../lib/api';
import { useNotification } from '../../../shared/Notification/useNotification';

const validationSchema = yup.object({
  email: yup
    .string()
    .required(i18n.t('accountSettings:emailForm.errors.blankEmail'))
    .email(i18n.t('accountSettings:emailForm.errors.invalidEmail')),
});

const updateEmail = ({ email }) => {
  return api({
    method: 'patch',
    url: '/api/account_settings/update_email',
    data: { email },
  });
};

const useEmailForm = () => {
  const queryClient = useQueryClient();
  const { presentationEmail } = queryClient.getQueryData(['accountSettings']);
  const { t } = useTranslation(['shared, accountSettings']);
  const { showSuccess } = useNotification();
  const { mutate } = useMutation(updateEmail);

  const initialValues = {
    email: presentationEmail,
  };

  const onSubmit = (values, { setFieldError }) => {
    mutate(values, {
      onSuccess: ({ data }) => {
        queryClient.setQueryData(['accountSettings'], data.settings);
        showSuccess({
          content: data.message,
          title: t('accountSettings:emailForm.title'),
        });
      },
      onError: () => {
        setFieldError(
          'email',
          t('accountSettings:emailForm.errors.takenEmail'),
        );
      },
    });
  };

  const form = useForm({
    onSubmit,
    initialValues,
    enableReinitialize: true,
    validationSchema,
  });

  return form;
};

export default useEmailForm;
